import client from "../services/api"

export const getOperators = (page?: number) => {
    return client.get('/operators', {params: {page}})
}

export const getOperatorById = (id?: string) => {
    return client.get(`/operators`, {params: {id}})
}

export const createOperator = (data: object) => {
    return client.post('/operators', data)
}

export const deleteOperator = (id: number) => {
    return client.delete(`/operators/${id}`)
}

export const updateOperator = (id: number | string, data:object) => {
    return client.patch(`/operators/${id}`, data)
}

export const getOperatorPackages = (operator: string) => {
    return client.post('/package-list', {operator})
}